// Escudo do clube e arte dos trofeus.

import React, { useState } from 'react';
import { crestStyle, crestImagePath } from '../data/crests.js';

/**
 * Escudo. Tenta a imagem em /escudos/<id>.png e, se nao existir, desenha.
 * O desenho e o padrao: o jogo funciona inteiro sem nenhum arquivo de imagem.
 */
export function Crest({ team, size = 34 }) {
  const [imgFailed, setImgFailed] = useState(false);
  const { primary, secondary, abbr } = crestStyle(team?.name);

  if (!imgFailed) {
    return (
      <img
        src={crestImagePath(team?.id)}
        alt=""
        width={size}
        height={size}
        style={{ borderRadius: 8, objectFit: 'contain', flex: '0 0 auto' }}
        onError={() => setImgFailed(true)}
      />
    );
  }

  const r = size / 2;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" style={{ flex: '0 0 auto' }} aria-hidden="true">
      <defs>
        <linearGradient id={`g${abbr}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={primary} stopOpacity=".95" />
          <stop offset="100%" stopColor={primary} stopOpacity=".72" />
        </linearGradient>
      </defs>
      {/* escudo: circulo com faixa diagonal na cor secundaria */}
      <circle cx="32" cy="32" r="30" fill={`url(#g${abbr})`} />
      <path d="M2 44 L62 20 L62 34 L2 58 Z" fill={secondary} opacity=".9" />
      <circle cx="32" cy="32" r="30" fill="none" stroke={secondary} strokeWidth="2.5" opacity=".85" />
      <text
        x="32" y="32" textAnchor="middle" dominantBaseline="central"
        fontSize="20" fontWeight="800" fill="#fff"
        style={{ paintOrder: 'stroke', letterSpacing: '-.02em' }}
        stroke="rgba(0,0,0,.45)" strokeWidth="3.5"
      >
        {abbr}
      </text>
      {void r}
    </svg>
  );
}

// ============================================================== TROFEUS ====

const TROPHY_ART = {
  // [corpo, brilho, rotulo]
  liga: ['#f6d76a', '#fff3c4', 'Campeao'],
  conferencia: ['#c4ced4', '#f1f5f9', 'Conferencia'],
  playoffs: ['#cd7f32', '#e8b184', 'Playoffs'],
  campanha: ['#60a5fa', '#bfdbfe', 'Melhor campanha'],
};

/**
 * Trofeu desenhado. Sao quatro pecas diferentes, nao quatro cores da mesma:
 * a taca da liga tem alcas e base alta, a de conferencia e um cone, a de
 * playoffs e uma placa, e a de campanha e um escudo.
 */
export function Trophy({ kind = 'liga', size = 64, dim = false }) {
  const [body, shine, label] = TROPHY_ART[kind] || TROPHY_ART.liga;
  const fill = dim ? '#2a323b' : body;
  const light = dim ? '#39424d' : shine;

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-label={label} role="img">
      {kind === 'liga' && (
        <>
          <path d="M20 10 h24 v14 a12 12 0 0 1 -24 0 z" fill={fill} />
          <path d="M20 12 h6 v12 a6 6 0 0 0 6 6 v4 a12 12 0 0 1 -12 -12 z" fill={light} opacity=".55" />
          <path d="M18 12 h-6 a8 8 0 0 0 8 8 z M46 12 h6 a8 8 0 0 1 -8 8 z" fill={fill} />
          <rect x="29" y="35" width="6" height="10" fill={fill} />
          <rect x="22" y="45" width="20" height="5" rx="1.5" fill={fill} />
          <rect x="19" y="50" width="26" height="6" rx="2" fill={fill} />
        </>
      )}
      {kind === 'conferencia' && (
        <>
          <path d="M22 12 h20 l-5 26 h-10 z" fill={fill} />
          <path d="M22 12 h6 l-3 26 h-3 z" fill={light} opacity=".5" />
          <rect x="29" y="38" width="6" height="8" fill={fill} />
          <rect x="21" y="46" width="22" height="6" rx="2" fill={fill} />
        </>
      )}
      {kind === 'playoffs' && (
        <>
          <rect x="14" y="14" width="36" height="30" rx="3" fill={fill} />
          <rect x="18" y="18" width="28" height="22" rx="2" fill={light} opacity=".35" />
          <rect x="24" y="44" width="16" height="6" rx="2" fill={fill} />
        </>
      )}
      {kind === 'campanha' && (
        <>
          <path d="M32 10 l20 7 v14 c0 12 -9 19 -20 23 c-11 -4 -20 -11 -20 -23 v-14 z" fill={fill} />
          <path d="M32 10 l-20 7 v14 c0 12 9 19 20 23 z" fill={light} opacity=".35" />
        </>
      )}
    </svg>
  );
}

export { TROPHY_ART };
